import { useCallback, useEffect, useState } from "react";
import { openPanel } from "@/reducers/panelsReducer.jsx";

// Planner run started from the new-voyage card counts as a new voyage until it is saved or the planner closes.
export default function usePlanVoyageForVessel({
  dispatch,
  setMarkedVesselNames,
  plannerOpen,
  setVoyageActive,
  setSwitchVoyagePlannerActive,
  setToogleButtonsOnOff,
}) {
  const [newVoyageVesselId, setNewVoyageVesselId] = useState(null);

  useEffect(() => {
    if (!plannerOpen) setNewVoyageVesselId(null);
  }, [plannerOpen]);

  const planVoyageForVessel = useCallback(
    (vessel) => {
      const vesselId = Number(vessel?.id);
      if (!Number.isInteger(vesselId) || vesselId <= 0) return;
      setMarkedVesselNames([{ vesselName: vessel?.name ?? "", vesselId }]);
      setNewVoyageVesselId(vesselId);
      dispatch(openPanel("voyagePlanner"));
      // Same switches as the drawer: without them VoyagePlannerController ignores map clicks.
      setVoyageActive(true);
      setSwitchVoyagePlannerActive(true);
      setToogleButtonsOnOff((prev) =>
        prev.includes("VoyagePlanner") ? prev : [...prev, "VoyagePlanner"],
      );
    },
    [dispatch, setMarkedVesselNames, setVoyageActive, setSwitchVoyagePlannerActive, setToogleButtonsOnOff],
  );

  const endNewVoyagePlan = useCallback(() => setNewVoyageVesselId(null), []);

  return { planVoyageForVessel, newVoyageVesselId, endNewVoyagePlan };
}
